import React from "react"
import { Card, CardBody } from "reactstrap"
import SimpleBar from "simplebar-react"
import CPSRequestCreated from "./ActivityListItems/CPSRequestCreated"
import CPSOffer from "./ActivityListItems/CPSOffer"
import CPSAcceptOffer from "./ActivityListItems/CPSAcceptOffer"
import CPSGoodsShipped from "./ActivityListItems/CPSGoodsShipped"
import CPSGoodsReceived from "./ActivityListItems/CPSGoodsReceived"
import CPSSampleProduction from "./ActivityListItems/CPSSampleProduction"
import CPSSampleApproval from "./ActivityListItems/CPSSampleApproval"
import CPSProduction from "./ActivityListItems/CPSProduction"
import CPSStockManagement from "./ActivityListItems/CPSStockManagement"
import CPSStockNotifications from "./ActivityListItems/CPSStockNotifications"
import CPSSubVersions from "./ActivityListItems/CPSSubVersions"

const Activity = ({ entry, myUser, statusIndex, reload }) => {
  // Determine current status index based on entry statusIndex from API
  const currentStatusIndex = entry?.statusIndex || 1

  // Helper function to check if a step should be shown
  const shouldShowStep = stepIndex => {
    return stepIndex <= currentStatusIndex
  }

  // Helper function to check if a step is active
  const isStepActive = stepIndex => {
    return stepIndex === currentStatusIndex
  }

  return (
    <Card>
      <CardBody>
        <div className="d-flex align-items-start">
          <div className="me-2">
            <h5 className="card-title mb-4">Activity</h5>
          </div>
        </div>
        <SimpleBar className="mt-2">
          <ul className="verti-timeline list-unstyled">
            {shouldShowStep(1) && (
              <CPSRequestCreated entry={entry} statusIndex={1} />
            )}

            {(shouldShowStep(2) ||
              (entry?.statusIndex === 1 &&
                entry?.cpsLabID === myUser?.company?.id)) && (
              <CPSOffer
                entry={entry}
                myUser={myUser}
                statusIndex={2}
                reload={reload}
              />
            )}

            {(shouldShowStep(3) ||
              ((entry?.statusIndex === 2 || entry?.statusIndex === 3) &&
                entry?.requestorCompanyID === myUser?.company?.id)) && (
              <CPSAcceptOffer
                entry={entry}
                myUser={myUser}
                statusIndex={3}
                reload={reload}
              />
            )}

            {/* Sub-Versions step - only for parent requests after offer acceptance */}
            {entry?.isParentRequest === 1 && shouldShowStep(4) && (
              <CPSSubVersions
                entry={entry}
                myUser={myUser}
                statusIndex={4}
                reload={reload}
              />
            )}

            {/* For parent requests, limit to only inquiry and stock management */}
            {entry?.isParentRequest === 1 ? (
              <>
                {/* Only show stock management for parent requests */}
                {entry?.needType === "annual" && shouldShowStep(5) && (
                  <CPSStockManagement
                    entry={entry}
                    myUser={myUser}
                    statusIndex={5}
                    reload={reload}
                  />
                )}
              </>
            ) : (
              <>
                {/* Regular workflow for non-parent requests */}
                {/* Skip CPSGoodsShipped and CPSGoodsReceived steps for subrequests (requests with a parent) */}
                {!entry?.parentRequestNumber && !entry?.parentID && shouldShowStep(4) && (
                  <CPSGoodsShipped
                    entry={entry}
                    myUser={myUser}
                    statusIndex={4}
                    reload={reload}
                  />
                )}

                {!entry?.parentRequestNumber && !entry?.parentID && shouldShowStep(5) && (
                  <CPSGoodsReceived
                    entry={entry}
                    myUser={myUser}
                    statusIndex={5}
                    reload={reload}
                  />
                )}
              </>
            )}
            {/* Sample and Production steps only for sub-requests, not parent requests */}
            {entry?.isParentRequest != 1 &&
              entry?.sampleRequired == 1 &&
              (shouldShowStep(7) ||
                (entry?.statusIndex === 6 &&
                  entry?.cpsLabID === myUser?.company?.id)) && (
                <CPSSampleProduction
                  entry={entry}
                  myUser={myUser}
                  statusIndex={7}
                  reload={reload}
                />
              )}

            {entry?.isParentRequest != 1 &&
              entry?.sampleRequired == 1 &&
              (shouldShowStep(7) ||
                (entry?.statusIndex === 7 &&
                  entry?.requestorCompanyID === myUser?.company?.id) ||
                (entry?.sampleDeclined == 1 &&
                  entry?.statusIndex < 8 &&
                  entry?.requestorCompanyID === myUser?.company?.id)) && (
                <CPSSampleApproval
                  entry={entry}
                  myUser={myUser}
                  statusIndex={7}
                  reload={reload}
                />
              )}

            {entry?.isParentRequest != 1 &&
              (shouldShowStep(entry?.sampleRequired ? 9 : 7) ||
                (entry?.statusIndex === 6 &&
                  entry?.sampleRequired === 0 &&
                  entry?.cpsLabID === myUser?.company?.id) ||
                (entry?.statusIndex === 8 &&
                  entry?.cpsLabID === myUser?.company?.id)) && (
                <CPSProduction
                  entry={entry}
                  myUser={myUser}
                  statusIndex={entry?.sampleRequired ? 9 : 7}
                  reload={reload}
                />
              )}

            {/* Stock Notifications for annual needs - only for sub-requests */}
            {entry?.isParentRequest != 1 &&
              entry?.needType === "annual" &&
              shouldShowStep(entry?.sampleRequired ? 10 : 8) && (
                <CPSStockNotifications
                  entry={entry}
                  myUser={myUser}
                  statusIndex={entry?.sampleRequired ? 10 : 8}
                  reload={reload}
                />
              )}
          </ul>
        </SimpleBar>
      </CardBody>
    </Card>
  )
}

export default Activity
